import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';

export const addArticle = async (articleData, image, pdf) => {
    try {
        articleData.author = firebase.auth().currentUser.uid;
        if (image) {
            articleData.imageName = image.name;
        }
        if (pdf) {
            articleData.pdfName = pdf.name
        }
        const docSnapshot = await firebase.firestore().collection('articles').add(articleData)
        if (image) {
            await uploadArticleImage(image, docSnapshot.id)
        }
        if (pdf) {
            await uploadArticlePDF(pdf, docSnapshot.id)
        }
        return docSnapshot.id;
    }
    catch(error) {
        // eslint-disable-next-line
        throw 'Couldn\'t publish the article. Please try again later';
    }
}

export const editArticle = async (articleId, articleData, image) => {
    try {
        delete articleData.imageURL;
        if (image) {
            articleData.imageName = image.name;
        } else {
            delete articleData.imageName;
            delete articleData.imagePath;
        }
        articleData.authorEdit = true;
        await firebase.firestore().doc(`articles/${articleId}`).set(articleData, { merge: true })
        if (image) {
            await uploadArticleImage(image, articleId)
        }
    }
    catch(error) {
        console.log(error)
        // eslint-disable-next-line
        throw 'Could\'nt update article! Please try again later.';
    }

}

const uploadArticleImage = async (image, articleId) => {
    const imageRef = firebase.storage().ref(`articles/${articleId}/${image.name}`);
    await imageRef.put(image)
        .catch(error => console.log(error));

}
const uploadArticlePDF = async (pdf, articleId) => {
    const pdfRef = firebase.storage().ref(`articles/${articleId}/${pdf.name}`);
    try {
        await pdfRef.put(pdf)
        const url = await pdfRef.getDownloadURL()
        await firebase.firestore().doc(`articles/${articleId}`).set({ pdfURL: url }, { merge: true })
    }
    catch(error) {
        console.log(error)
    }

}
export const getAllArticles = async (authorUID=null, limit=null, withImages=false, conditions=null) => {
    let articlesCollection = firebase.firestore().collection('articles');
    let query = articlesCollection.orderBy('time', "desc")
    if (authorUID) {
        query = query.where('author', '==', authorUID);
    }
    if (limit) {
        query = query.limit(limit)
    }
    const articlesSnapshot =  await query.get();
    const docs = articlesSnapshot.docs
    let articles = []
    let articleData
    if (withImages) {
        for (let i = 0; i < docs.length; i++) {
            articleData = docs[i].data()
            articleData.id = docs[i].id
            articleData.first = i === 0 ? true : false
            const imagePath = articleData.imagePath
            let imageDownloadURL
            if (imagePath) {
                try {
                    imageDownloadURL = await firebase.storage().ref(imagePath).getDownloadURL()
                }
                catch(error) {
                    if (error.code === "storage/object-not-found") {
                        imageDownloadURL = await firebase.storage().ref('defaultArticleImage.jpg').getDownloadURL()
                    }
                }
                finally {
                    articleData.imageURL = imageDownloadURL
                    articles.push(articleData)
                }
            } else {
                imageDownloadURL = await firebase.storage().ref('defaultArticleImage.jpg').getDownloadURL()
                articleData.imageURL = imageDownloadURL
                articles.push(articleData)
            }
        }
        return articles
    }
    return articlesSnapshot.docs;
}

export const getArticle = async (articleId) => {
    const articleSnapshot = await firebase.firestore().doc(`articles/${articleId}`).get();
    if (articleSnapshot.exists) {
        let articleData = articleSnapshot.data()
        articleData.id = articleSnapshot.id
        const imagePath = articleData.imagePath
        let imageDownloadURL
        try {
            imageDownloadURL = await firebase.storage().ref(imagePath).getDownloadURL()
        }
        catch(error) {
            if (error.code === "storage/object-not-found") {
                imageDownloadURL = await firebase.storage().ref('defaultArticleImage.jpg').getDownloadURL()
            }
        }
        finally {
            articleData.imageURL = imageDownloadURL
            return articleData;
        }
    }
    // eslint-disable-next-line
    throw 'Not found!'
}

export const deleteArticle = (articleId) => {
        return firebase.firestore().doc(`articles/${articleId}`).delete()
        // eslint-disable-next-line
            .catch(error => {throw 'Couldn\'t delete article! Check that you have suffecient permessions'})
}

export const getArticlesWithTag = async (tag) => {
    const articlesSnapshot = await firebase.firestore().collection('articles')
        .where('tags', 'array-contains', tag)
        .get()
    return articlesSnapshot.docs
}

export const getAllTagsAndAuthors = async () => {
    let tags = []
    let authors = []
    const articlesSnapshot = await firebase.firestore().collection('articles').get()
    articlesSnapshot.docs.forEach(doc => {
        const docData = doc.data()
        if (docData.tags) {
            tags = [...tags, ...docData.tags]
        }
        if (docData.authorName && authors.filter(a => a.name === docData.authorName).length === 0) {
            authors.push({name: docData.authorName, id: docData.author})
        }
    })
    tags = new Set(tags)
    return {
        tags: [...tags],
        authors: [...authors]
    }
}